(function () {
    'use strict';

    function statusSearchField() {
        return {
            restrict: 'E',
            scope: {
                attribute: '=',
                changeEvent: '&'
            },
            templateUrl: 'common/directives/templates/statusSearchField.html',
            link: function (scope, element, attrs) {
                scope.hasChangeEvent = attrs.changeEvent;
            }
        };
    }

    statusSearchField.$inject = [];

    angular.module('ecap.common').directive('statusSearchField', statusSearchField);
})();